import React, { Component } from "react";
import { Link } from "react-router-dom";

import { optionMasterService } from "app/_services/OptionMasterService/optionMasterService";

import toastr from "toastr";
import Prompt from "app/Components/IEnergyPrompt/Prompt";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

class AddCompany extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      error: {},
      projectId: this.props.match.params.id ? this.props.match.params.id : "",
      projectData: {},
      changeRoute: "",
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(e) {
    let checkNagetiveForValue = e.target.value !== "" ? e.target.value : "";
    let flag = 0;
    if (checkNagetiveForValue !== "") {
      flag = checkNagetiveForValue.slice(0, 1) === "-" ? 1 : 0;
    }
    if (flag === 0) {
      this.setState({ [e.target.name]: e.target.value, changeRoute: 1 });
    } else {
      this.setState({ [e.target.name]: "", changeRoute: 1 });
    }
  }

  componentDidMount() { }

  async onSubmit(e) {
    e.preventDefault();
    var obj = {
      project_id: 0,
      meta_key: this.state.name,
      meta_value: this.state.name,
      option_type: "company",
    };

    let data = await optionMasterService.createOptionMaster(obj, 0);

    if (data && data.status === 1) {
      this.setState({
        changeRoute: "",
      });
      toastr.success("Organisation Created Successfully");
      this.props.history.push("/user-management/company");
    } else if (data && data.message) {
      toastr.warning(data.message);
    }
  }

  render() {
    console.log("this", this.state);
    return (
      <div>
        <MainBreadcrumb
          routeSegments={[
            { name: "User Management", path: "#" },
            { name: "Organisation", path: "/user-management/company" },
            { name: "Add" },
          ]}
          breadCrumbsText="User_Management_Organization"
        />
        <Prompt changes={this.state.changeRoute}></Prompt>
        <div className="row d-flex justify-content-center">
          <div className="col-md-5">
            <div className="card mt-4 mb-3" style={{ overflow: "visible" }}>
              <div className="card-body">
                <div className="simple-card-title">
                  <h3 class="text-capitalize mb-1">Add Organisation</h3>
                </div>
                <form onSubmit={this.onSubmit}>
                  <div className="row">
                    <div className="col-md-12 form-group mb-3">
                      <label>Organisation Name</label>
                      <input
                        name="name"
                        type="text"
                        className="form-control"
                        placeholder="Enter Organisation Name"
                        onChange={this.onChange}
                        value={this.state.name}
                        required
                      />
                    </div>
                    <div className="col-md-12 text-center">
                      <Link
                        to="/user-management/company"
                        className="btn btn-secondary mr-2"
                      >
                        Back
                      </Link>
                      <button className="btn btn-primary ml-2">Submit</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddCompany;
